exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addlist[data-v-4e9d7c77]{margin-top:20px;padding-right:20px;padding-left:20px}.addlist ol[data-v-4e9d7c77]{display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0}.addlist ol li[data-v-4e9d7c77]{width:49%;margin-left:20px}.addlist ol li[data-v-4e9d7c77]:nth-child(1){margin-left:0}.addlist ul[data-v-4e9d7c77]{padding-right:20px}.addlist ul li[data-v-4e9d7c77]{width:100%}\n", ""]);

// exports
